import { MutationTree } from 'vuex'

import { AppState } from '@/@next/store/app'
import * as APP from '@/@next/store/app/types'

import { NetworkStatus } from '@/@next/@types'

export const mutations: MutationTree<AppState> =  {

  [APP.APP_IS_READY] (state, value: boolean) {
    state.isReady = value
  },

  [APP.SET_NETWORK] (state, network: NetworkStatus) {
    state.network = network
  },

  [APP.ADD_MODAL] (state, modal: any) {
    state.modals.push(modal)
  },

  [APP.REMOVE_CURRENT_MODAL] (state) {
    state.modals.splice(0, 1)
  },

  [APP.REMOVE_MODAL] (state, modal: any) {
    const index = state.modals.findIndex((m: any) => m === modal)
    if (index !== -1) {
      state.modals.splice(index, 1)
    }
  },

  [APP.SERVICE_WORKER_IS_READY] (state, value: boolean) {
    console.log('[Info][App] Service Worker is ready !');
    state.serviceWorkerIsReady = value
  },

  // Preloader Mutations
  [APP.PRELOAD_DATASET] (state, dataset: any) {
    state.preloadDataset = dataset
  },

  [APP.PRELOAD_STATUS] (state, status: string) {
    state.preloadStatus = status
  },

  [APP.DISPLAY_PRELOAD_STATUS] (state, display: boolean) {
    state.displayPreloadStatus = display
  },

  [APP.ACCEPT_PRELOAD] (state, accept: boolean) {
    state.acceptPreload = accept
  },

  [APP.PRELOAD_SUCCESS] (state, success: boolean) {
    state.preloadSuccess = success
    if (success) state.preloadError = false
  },

  [APP.PRELOAD_ERROR] (state, error: boolean) {
    state.preloadError = error
    if (error) state.preloadSuccess = false
  },

  [APP.NEED_TO_RELOAD_APP] (state, needToReloadApp: boolean) {
    state.needToReloadApp = needToReloadApp
  }

}
